export const GatewayFeesFields = {
	MonthlyFee: { name: "monthlyFee", displayName: "Monthly Fee, $" },
	TransactionFee: {
		name: "transactionFee",
		displayName: "Transaction Fee, $",
	},
	Level3PerTransactionFee: {
		name: "level3PerTransactionFee",
		displayName: "Level 3 Per Trans Fee, $",
	},
	SetupFee: { name: "setupFee", displayName: "Gateway Setup Fee, $" },
	VaultMonthlyFee: {
		name: "vaultMonthlyFee",
		displayName: "Vault Monthly Fee, $",
	},
};
